var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaduceus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2862_13446)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.7273,
    fill: "#411EF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 10.4811L21.9607 8.29039C21.8562 8.17044 21.7147 8.0887 21.5586 8.0581L21.5246 8.05167L18.1871 7.41538C18.1293 7.23741 18.0239 7.07865 17.8823 6.9563C17.784 6.8709 17.6654 6.8121 17.538 6.78553H17.5169L13.2869 5.97479C13.1884 5.95551 13.087 5.95551 12.9885 5.97479L9.32779 6.6175C8.66672 6.7387 8.34261 7.39335 8.36556 7.97822L8.43626 9.88248L5.53304 9.33158C5.37284 9.30594 5.20863 9.32868 5.06142 9.39689C4.91422 9.46509 4.79071 9.57566 4.70669 9.71446L2.77856 12.6526C2.50219 13.0547 2.4168 13.6717 2.82906 14.1391L8.83566 20.916L9.26903 32.5032C9.28739 33.0486 9.5711 33.4489 9.99437 33.5251L14.2418 34.334H14.2491C14.3012 34.3435 14.3541 34.3481 14.407 34.3478C14.4742 34.3477 14.5413 34.3413 14.6072 34.3285L17.022 33.9015C17.6032 33.8024 17.9567 33.1881 17.9631 32.6519L18.0999 20.9059L23.9532 11.9805C24.2773 11.4957 24.2543 10.8768 23.8999 10.4811ZM8.85677 7.59993L12.6681 8.32528C12.6286 8.47498 12.6113 8.62964 12.6166 8.78436L12.7828 13.3045L10.1854 10.3663C10.0807 10.2459 9.93886 10.1638 9.78228 10.1331L9.74647 10.1258L8.88616 9.96236L8.81178 7.95342C8.80707 7.83391 8.82227 7.71445 8.85677 7.59993V7.59993ZM3.15041 12.895L5.07855 9.95685C5.11402 9.8944 5.16701 9.84373 5.23098 9.81109C5.29495 9.77845 5.36709 9.76528 5.43847 9.77322L9.00643 10.449C8.98899 10.471 8.97246 10.4931 8.95685 10.5169L7.02872 13.455C6.94409 13.5864 6.88202 13.731 6.84509 13.8829L3.03105 13.1585C3.05703 13.065 3.0973 12.9761 3.15041 12.895V12.895ZM9.17813 20.6167L3.16969 13.837C3.11309 13.7749 3.06939 13.7022 3.04115 13.6231L6.81203 14.342C6.83828 14.5683 6.93458 14.7808 7.08748 14.9498L12.7075 21.2924L9.17813 20.6167ZM10.0788 33.0789C9.76116 33.0238 9.72627 32.5766 9.72352 32.4866L9.29749 21.1015L13.0987 21.8259L13.5284 33.313C13.5323 33.4623 13.5596 33.6101 13.6092 33.751L10.0788 33.0789ZM13.5789 7.42273C13.4332 7.44949 13.2944 7.50551 13.171 7.58742C13.0476 7.66932 12.9421 7.77541 12.8609 7.89925L9.1212 7.18676C9.20112 7.12221 9.29573 7.07837 9.39665 7.05914L13.0574 6.41643C13.103 6.40819 13.1497 6.40881 13.1951 6.41826L16.124 6.9765L13.5789 7.42273ZM20.7323 8.4428L18.2036 12.2945L18.245 7.88732L20.78 8.37027C20.7653 8.39506 20.7479 8.41893 20.7323 8.4428V8.4428Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2862_13446"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.27271,
    y: 1.27271,
    width: 25.4545,
    height: 25.4545,
    rx: 12.7273,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaduceus);
export default __webpack_public_path__ + "static/media/caduceus.d2712468983a7bb4b886d30fce7735b2.svg";
export { ForwardRef as ReactComponent };